import { useQuery, UseQueryOptions } from 'react-query';
import {
  CitiesResponseInterface,
  CityTransformDataInterface,
} from '@interface/cities';
import { SuggestionInterface } from '@components/ui/AutoComplete';
import apiService from './config';

const transformData = (data: CitiesResponseInterface['data']) =>
  data.map((item) => ({
    ...item,
    id: item.cityId.toString(),
  }));

function getCitiesSuggestions(
  description: string,
): Promise<CityTransformDataInterface[]> {
  return apiService
    .get(`federation/cities/suggest?city_name=${description}`)
    .then((res) => transformData(res.data));
}

export function useCitiesSuggestions(
  description: string,
  options?: UseQueryOptions<SuggestionInterface[], Error>,
) {
  return useQuery<SuggestionInterface[], Error>(
    ['cities-suggestions', description],
    () => getCitiesSuggestions(description),
    {
      ...options,
      enabled: Boolean(description) && description.length > 1,
      refetchOnWindowFocus: false,
      suspense: false,
    },
  );
}
